import { DEFAULT_FONT_FAMILY } from 'common/constants';
import styled from 'styled-components';

interface IStyleProps {
  widthValue?: string;
  cursorValue?: string;
}

export const Root = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const DragContainer = styled.div`
  display: flex;
  width: 547px;
  padding-bottom: 20px;
  overflow-x: overlay;
  overflow-y: hidden;
`;

export const Item = styled.div`
  display: flex;
`;

export const DropArea = styled.div`
  width: ${(props: IStyleProps) => (props.widthValue ?? '15px')};
  height: 100%;
  transition: width 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  cursor: ${(props: IStyleProps) => (props.cursorValue ?? 'auto')};
`;

export const Card = styled.div`
  width: ${(props: IStyleProps) => (props.widthValue ?? '87px')};
  height: 93px;
  padding: ${(props: IStyleProps) => (props.widthValue ? '0px' : '10px')};
  opacity: ${(props: IStyleProps) => (props.widthValue ? '0' : '1')};
  border-radius: 10px;
  box-sizing: border-box;
  border: ${(props: IStyleProps) => (props.widthValue ? 'auto' : 'solid 1px #bdbdbd')};
  cursor: ${(props: IStyleProps) => (props.cursorValue ?? 'grab')};
  overflow: hidden;
  transition: width 0.2s, opacity 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const CardDetail = styled.div`
  display: -webkit-box;
  height: 42px;
  margin: 6px 0px;
  font-size: 12px;
  font-weight: 300;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #272727;
`;

export const CardStars = styled.div`
  padding-top: 5px;
`;

